import React from 'react';
import { connect } from 'react-redux'

import IndexComponent from '../components/IndexComponent.js';

const IndexContainer = React.createClass({
  componentDidMount() {
    const body = document.getElementsByTagName('body')[0];
    document.title = 'Nathan Kleekamp | Home';
    body.className = 'home';
    this.setMetaDescription();
  },

  setMetaDescription() {
    const desc = document.querySelectorAll('meta[name=description');
    desc[0].content = "I am a developer with more than 5 years of experience developing web-based applications."
  },

  render() {
    const props = this.props;

    return (
      <IndexComponent data={ props.data }/>
    );
  }
});




/*
 * Standard Redux mapStateToProps function.
 *
 * @param {Object} state.app - The app object in the Redux store
 *
 * @return {Object} IndexContainerPropsObject - Data from state mapped to the MainContainer's props
 *
 * @since 2.0.0
 */

const mapStateToProps = ({ app }) => {
  const data = app.data;
  const isFetching = app.isFetching;


  /*
   * @typedef {Object} MainContainerPropsObject
   * @property {Boolean} isFetching - Is the application in the state of fetching data
   * @property {Object} portfolio - The portfolio data from state
   */

  return {
    isFetching,
    data
  };
};


export default connect(mapStateToProps)(IndexContainer);



// WEBPACK FOOTER //
// ./app/src/Home/containers/IndexContainer.js